import AUStates from './ar-SA/AU-states.json.js';
import CAStates from './ar-SA/CA-states.json.js';
import CNStates from './ar-SA/CN-states.json.js';
import CompanySize from './ar-SA/company-size.json.js';
import CompanyType from './ar-SA/company-type.json.js';
import countries from './ar-SA/countries.json.js';
import DEStates from './ar-SA/DE-states.json.js';
import HKStates from './ar-SA/HK-states.json.js';
import INStates from './ar-SA/IN-states.json.js';
import industry from './ar-SA/industry.json.js';
import interests from './ar-SA/interests.json.js';
import jobRole from './ar-SA/job-role.json.js';
import levelOfAWSUsage from './ar-SA/level-of-aws-usage.json.js';
import projectTimeline from './ar-SA/project-timeline.json.js';
import PTStates from './ar-SA/PT-states.json.js';
import USStates from './ar-SA/US-states.json.js';
import useCase from './ar-SA/use-case.json.js';
import languagePreference from './ar-SA/language-preference.json.js';
import Navatar from '../ar-SA/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
